export default __webpack_public_path__ + "static/media/IMG-2734.a3d99363.jpg";